<template>
    <div>
        <div
            v-if="value"
            v-html="value"
            :id="shortened ? '' : 'longDescription'"
        ></div>

        <a
            v-if="shortened && value.length > maxLength"
            @click="scrollToLongDescription()"
            class="d-block font-weight-bold text-underline short-description-more"
        >
            {{$language.translate('more product info >')}}
        </a>
    </div>
</template>

<style>
.short-description-more {
    color: inherit;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex';

const parentModuleName = 'Product';
const { mapState, mapGetters } = createNamespacedHelpers(parentModuleName);

export default {
    name: 'ProductLongDescription',
    props: {
        shortened: Boolean,
        maxLength: {
            type: Number,
            default: 250,
        },
    },
    computed: {
        value() {
            let value = this.getProductAttributeByLanguage(this.product, 'product.description.long');

            if (this.shortened && this.maxLength) {
                value = value.substring(0, this.maxLength) + (value.length > this.maxLength ? '...' : '');
            }

            return value;
        },
        ...mapState(['product']),
        ...mapGetters(['getProductAttributeByLanguage']),
    },
    methods: {
        scrollToLongDescription() {
            let container = document.querySelector("#longDescription");
            if (typeof container.scrollIntoView === 'function') {
                container.scrollIntoView();
            } else {
                window.scrollTo(0, container.scrollTop);
            }
        },
    },
};
</script>